import React from "react";

import { appstoredb } from "./db";

import "./style.css";
import Navbar from "../../Components/Navbar";
import Slider from "./Slider";
import { useMediaQuery } from "react-responsive";
const AppStore = () => {
  const isMobile = useMediaQuery({ maxWidth: 480 });
  console.log(isMobile);
  return (
    <div className="appstore">
      <Navbar />
      {appstoredb.map((item, index) => (
        <div className="appstore_wrapper" key={index}>
          <div className="section-1">
            <div className="right-title">
              <h2>{item.title}</h2>
            </div>
            <div className="left-image">
              <img src={item.image} alt="Instagram Clone" />
            </div>
          </div>
          <hr />
          <div className="section-2">
            <div className="section-2-slider">
              <Slider width={isMobile ? 150 : 272} images={item.images} />
            </div>
            <div className="section-2-para">
              <p>{item.desc}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default AppStore;
